import React, { Component } from "react";
import MaterialTable from "material-table";
import { Row, Col, Card, CardBody, FormGroup, Input, Label } from "reactstrap";
import history from "../../history";
import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import FilterCard from "../filterCard";
import Loader from "../Loader";
import get from "lodash/get";
import BranchDetail from "../BranchDetail";
import { fetchQueryParams } from "../../utils/comman";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import CustomDatepicker from "../CustomDatepicker";

const _ = { get };

export default class TestimonialQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      page: 0,
      pageSize: 10,
      countryCode: "",
      country: "",
      state: "",
      city: "",
      dealerEmail: "",
      dealerPhone: "",
      dealerId: "",
      status: "PENDING",
      count: 100,
      selectedId: "",
      toggleModal: false,
      countryList: [],
      parsedCountry: "",
    };
  }

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        <div className="hideSearch custom-m-table mt-4">
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "branchListingFilterElements.headingElement",
                  "Testimonials"
                )}
                iconClass={"hideexcel"}
                Name={_.get(
                  elements,
                  "branchListingFilterElements.filterButtonElement",
                  "Add New"
                )}
                handleToggle={() => this.handleToggle()}
                textTitle={_.get(
                  elements,
                  "branchListingFilterElements.totalCountElement",
                  "Total Count - "
                )}
                preRegisteredUserCount={this.props.branchCount}
              />
            </Col>
            <Col sm={12}>
            <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col xl={4} lg={4} md={6} sm={6}>
                      {/* <Label className="inputLabel">
                      Select Category                    
                      </Label> */}
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          // value={parsedCountry}
                        >
                          <option>All countries</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={6}>
                      {/* <Label className="inputLabel">
                      Select City
                      </Label> */}
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                        >
                          <option>Select State</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={6}>
                      {/* <Label className="inputLabel">
                      Select City
                      </Label> */}
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                        >
                          <option>Select City</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={4}>
                        <InputText
                          labelName="Email"
                          inputType={"text"}
                          inputName={"firstName"}
                          InputClass={"inputText mb-0"}
                          inputPlaceholder={_.get(
                            elements,
                            "userMembershipListingFilterElements.firstNamePlaceholder",
                            "Email"
                          )}
                        />
                      
                    </Col>
                    <Col xl={4}>
                        <InputText
                          labelName="Phone"
                          inputType={"text"}
                          inputName={"firstName"}
                          InputClass={"inputText mb-0"}
                          inputPlaceholder={_.get(
                            elements,
                            "userMembershipListingFilterElements.firstNamePlaceholder",
                            "Phone"
                          )}
                        />
                      
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-flex mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "landingPageElement.searchButtonElement",
                            "Search"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          // customClick={() => handleSearch()}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "landingPageElement.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          // customClick={() => handleClearFilter()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
             
                  <Row>
                    <Col xl={3} lg={3} md={6} sm={6}>
                      <Label className="inputLabel">Status</Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          // value={parsedCountry}
                        >
                          <option>Pending</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.nameElement",
                      "Partner"
                    ),
                    field: "branchName",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.emailElement",
                      "Email"
                    ),
                    field: "emailId",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.phoneElement",
                      "Rider Name"
                    ),
                    field: "phone",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.clubCoordinatorNameElement",
                      "Rider Location"
                    ),
                    field: "storeManagerName",
                  },
                  {
                    title: _.get(
                      elements,
                      "branchListingTableElements.moderationStatusElement",
                      "Posted Date"
                    ),
                    field: "moderationStatus",
                  },
                ]}
                data={this.props.branches}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: "Detail Page",
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                // onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                // onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "branchListingTableElements.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "branchListingTableElements.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}
